import * as R from 'ramda';

export interface Gender {
  id: number;
  name: string;
}

export const genders: Gender[] = [
  { id: 1, name: 'female' },
  { id: 2, name: 'male' },
  { id: 3, name: 'unisex' },
  { id: 4, name: 'kinder' },
  { id: 5, name: 'jungen' },
  { id: 6, name: 'maedchen' },
];

export function genderById(id: number) {
  const possibleGender = genders.filter(gender => gender.id === id);

  return possibleGender.length > 0 ? possibleGender[0] : null;
}

export function genderByName(name: string): Gender | undefined {
  return R.find(R.propEq('name', name))(genders) as Gender | undefined;
}

export function genderIdByName(name: string): number {
  const gender = genderByName(name);
  return gender ? gender.id : 1;
}



// WEBPACK FOOTER //
// ./src/utils/gender.ts